var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1343 1.50293L12.1722 4.34635L6.83701 10.6095L1.50171 4.34635L3.53971 1.50293H10.1343Z",
    fill: "#A5E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1024 5.62585L6.7726 1.50293H6.02686L9.71685 6.01125L10.1024 5.62585Z",
    fill: "#61D7FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21582 6.27016L5.22242 1.50293H3.53991L3.21692 1.95363L8.83027 6.65571L9.21582 6.27016Z",
    fill: "#61D7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53266 7.05155L2.91324 2.37695L2.56824 2.85832L8.14727 7.43695L8.53266 7.05155Z",
    fill: "#61D7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6626 5.06598L7.78501 1.50293H7.41418L10.4799 5.2485L10.6626 5.06598Z",
    fill: "#61D7FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47642 5.02539L6.83709 10.6093L4.19775 5.02539H9.47642Z",
    fill: "#41B7FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19768 5.02591L1.50171 4.34668L6.83702 10.6098L4.19768 5.02591Z",
    fill: "#61D7FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83691 10.6098L9.47625 5.02591L12.1721 4.34668L6.83691 10.6098Z",
    fill: "#008BD7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53971 1.50293H5.76965L4.19768 5.02558L1.50171 4.34635L3.53971 1.50293Z",
    fill: "#C0EDF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1346 1.50293H7.90466L9.47663 5.02558L12.1725 4.34635L10.1346 1.50293Z",
    fill: "#41B7FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.47635 4.65342H4.19768L1.50171 4.34668L4.19768 5.02591H9.47635L12.1722 4.34668L9.47635 4.65342Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62864 4.51005L5.65334 4.74587L4.62864 4.9817L4.39297 6.00639L4.15699 4.9817L3.13245 4.74587L4.15699 4.51005L4.39297 3.48535L4.62864 4.51005Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46349 5.14784L10.0518 5.28314L9.46349 5.41844L9.32819 6.00672L9.19274 5.41844L8.60461 5.28314L9.19274 5.14784L9.32819 4.55957L9.46349 5.14784Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83701 9.30266L1.50171 4.34668L6.83701 10.6098L12.1722 4.34668L6.83701 9.30266Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.5538ba765aebbedd120e61f4bf398201.svg";
export { ForwardRef as ReactComponent };